// extracted by mini-css-extract-plugin
export default {"ScoreContainer":"Score_ScoreContainer__An7MR"};